<template>
    <v-layout class="mt-3 pl-3" row wrap>
        <v-flex xs12>
            <v-autocomplete
                :label="$vuetify.lang.t('$vuetify.relationship_with_dependent')"
                outlined
                type="text"
                class="pr-2"
                :items="options"
                :rules="[rules.required]"
                v-model="visa.extra.application_data.relation"
            ></v-autocomplete>
        </v-flex>
        <v-flex xs12>
            <confirmation-header-text :text="$vuetify.lang.t('$vuetify.dependent_person_detail')"
                                      class="ml-0"
                                      icon="mdi-account-multiple"></confirmation-header-text>
        </v-flex>
        <v-flex xs3>
            <list-item-detail :title="$vuetify.lang.t('$vuetify.full_name')"
                              :sub_title="dependentVisaDetail.traveller.full_name"></list-item-detail>
        </v-flex>
        <v-flex xs3>
            <list-item-detail :title="$vuetify.lang.t('$vuetify.gender')"
                              :sub_title="dependentVisaDetail.traveller.gender"></list-item-detail>
        </v-flex>
        <v-flex xs3>
            <list-item-detail :title="$vuetify.lang.t('$vuetify.contact_no')"
                              :sub_title="dependentVisaDetail.traveller.contact_number"></list-item-detail>
        </v-flex>

    </v-layout>
</template>

<script>

    import {mapGetters} from "vuex";
    import ListItemDetail from "../../ListItemDetail";
    import {validationMixin} from "../../../mixins/validationMixin";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";
    import {fetchDynamicValues} from "../../../helpers/dynamicValueHelper";

    export default {
        data() {
            return {
                options: []
            }
        },
        mixins: [validationMixin],
        components: {
            ListItemDetail,
            ConfirmationHeaderText
        },
        computed: {
            ...mapGetters('VisaSingle', ['extendConvertData', 'visa', 'dependentVisaDetail']),
        },
      mounted() {
        fetchDynamicValues('Relations').then((data) => {
          this.options = data;
        });
      }

    };
</script>

<style>
</style>
